<script>
    import { onMount } from 'svelte';
    
    export let emotionData;
    export let onNext;
    let imagePath = {};

    onMount(() => {
        ['A', 'B', 'C', 'D'].forEach(option => {
            imagePath[option] = `/imgs/${emotionData.name}/${option}.jpg`;
        });
    });
    $: {
        // This block will run whenever emotionData.name changes
        ['A', 'B', 'C', 'D'].forEach(option => {
            imagePath[option] = `/imgs/${emotionData.name}/${option}.jpg`;
        });
    }

    function selectOption(option) {
        console.log(emotionData.correct);
        if (emotionData.correct === option) {
            emotionData.points = 1; // track points for a correct answer
        } else {
            emotionData.points = 0;
        }
        onNext(); // proceed to the next question
    }

</script>

<p class="instruction-text">
    Choose the facial expression that does 
    <span class="accent-text">NOT</span> display a facial expression of 
    <span class="emotion-name">{emotionData.name}</span>
</p>

<div class="options">
    {#each ['A', 'B', 'C', 'D'] as option}
        <button class="option-button" on:click={() => selectOption(option)}>
            <img src={imagePath[option]} alt={option} class="option-image" />
        </button>
    {/each}
</div>

<style>
    .instruction-text {
        font-size: 1.2em; /* Adjust the size as needed */
        color: #333; /* Standard text color, keep in sync with body color */
        margin: 20px 0; /* Space around the paragraph */
        line-height: 1.4; /* Adjust line spacing for better readability */
        text-align: center; /* Center the text if it fits with your design */
    }

    .accent-text {
        color: #d9534f; /* A color that stands out */
        font-weight: bold; /* Make 'NOT' bold */
    }

    .emotion-name {
        color: #4a90e2; /* Color used in headings and buttons */
        font-weight: bold; /* Make the emotion name stand out */
    }

    .options {
        display: grid;
        grid-template-columns: repeat(2, 1fr); /* 2 columns, same as before */
        grid-gap: 10px; /* reduced gap */
        margin-top: 20px;
        align-items: center;
        justify-items: center;
    }

    .option-button {
        width: 100%; /* Makes the button take the full width of the grid cell */
        height: 100%; /* Makes the button take the full height of the grid cell */
        padding: 10px;
        font-size: 18px;
        cursor: pointer;
        max-height: calc((80vh - 40px) / 2); /* limits the height of each button */
        padding: 5px; /* reduce padding to save space */
        border: none; /* Optional: remove the default border */
        background: transparent; /* Optional: remove the default background */
    }

    .option-image {
        max-width: 100%; /* full width of the container */
        max-height: 100%; /* adjusted to fit within the container */
        object-fit: contain; /* ensures image aspect ratio is maintained */
    }
</style>